export default __webpack_public_path__ + "static/christmas-tea-01-f8b272f53451b87e90452937981d3c99.webp";